import {React} from '@api';
import {styled} from '@pdf'

const CustomAttributePdfView = styled.View`
  display:flex;
  flex-direction: row;
  overflow: hidden;
`

export const SpecItemView = styled.View`
  overflow: hidden;
  display: flex;
  flex-direction: row;  
`

export const SpecLabelText = styled.Text`
  margin-left: 4px;
  padding-right: 4px;
  margin-top: auto;
  margin-bottom: auto;
  color: #1B1B1B;
  font-size:   8pt;
  display:flex;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export class CustomAttributePdf extends React.Component<{ style?: any, textStyle?: any, attributeLabel?: string, attributeValue?: string }> {
  render() {
    let {props: {style, textStyle, attributeLabel, attributeValue}} = this

    return (
      <CustomAttributePdfView>
        {attributeLabel && <SpecItemView style={style}>
          <SpecLabelText style={textStyle}>{attributeLabel}</SpecLabelText>
        </SpecItemView>}
        <SpecItemView style={style}>
          <SpecLabelText style={textStyle}>{attributeValue || '--'}</SpecLabelText>
        </SpecItemView>
      </CustomAttributePdfView>)
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/productCard/CustomAttributePdf.tsx